export default {
  rateInfoText: {
    id: 'pricing_tool-rate-text',
    defaultMessage:
      'Back Market will apply the most-recent currency conversion rate for you.',
  },
}
